import React, { useEffect, useRef } from 'react';
import { authLogger } from '../utils/logger';

const APP_ENV = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;
const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8080';
const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM || 'master';
const KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'nest-cedi';

const AuthWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Reference to store the session tracking interval
  const sessionTrackingInterval = useRef<NodeJS.Timeout | null>(null);
  
  // Function to periodically log session information
  const setupSessionTracking = () => {
    // Log session information every 30 minutes
    sessionTrackingInterval.current = setInterval(() => {
      try {
        const userStr = localStorage.getItem('user');
        if (userStr) {
          const userData = JSON.parse(userStr);
          const username = userData.preferred_username || userData.email || 'unknown';
          authLogger.logSessionInfo(username);
        }
      } catch (error) {
        console.error('Error logging session info:', error);
      }
    }, 30 * 60 * 1000); // 30 minutes in milliseconds
  };

  // Clear interval on component unmount
  useEffect(() => {
    return () => {
      if (sessionTrackingInterval.current) {
        clearInterval(sessionTrackingInterval.current);
      }
    };
  }, []);
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    // Debug log
    console.log('Environment:', {
      APP_ENV,
      KEYCLOAK_URL,
      KEYCLOAK_REALM,
      KEYCLOAK_CLIENT_ID
    });

    if (!token) {
      // Usa l'URL corrente come base per il redirect
      const baseUrl = window.location.origin + '/login';
      
      // Crea l'URL di redirect per Keycloak
      const redirectUrl = new URL(`${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/auth`);
      redirectUrl.searchParams.append('client_id', KEYCLOAK_CLIENT_ID);
      redirectUrl.searchParams.append('response_type', 'code');
      redirectUrl.searchParams.append('scope', 'openid profile email');
      redirectUrl.searchParams.append('redirect_uri', baseUrl);
      
      // Debug log
      console.log('Redirect URL:', redirectUrl.toString());
      
      // Usa replace per evitare problemi con la history del browser
      window.location.replace(redirectUrl.toString());
    } else {
      // If token exists, start session tracking
      setupSessionTracking();
    }
  }, []);

  return <>{children}</>;
};

export default AuthWrapper;